import { Box, Flex, Text } from '@chakra-ui/react';

interface ScrollDownLinkProps {
  /** id of the section to scroll to. */
  targetId: string;
  label: string;
}

/**
 * Vertical "Scroll Down" cue: rotated text (reads bottom-to-top) above a circle
 * with a down-chevron. Jumps to the next section anchor (smooth via global
 * scroll-behavior). Desktop-only; the parent aligns it to the block's outer edge.
 */
export function ScrollDownLink({ targetId, label }: ScrollDownLinkProps) {
  return (
    <Flex
      as="a"
      href={`#${targetId}`}
      direction="column"
      align="center"
      gap="16px"
      w="25px"
      color="#CCBABD"
      transition="opacity 0.15s"
      _hover={{ opacity: 0.65 }}
      display={{ base: 'none', lg: 'flex' }}
    >
      <Text
        sx={{ writingMode: 'vertical-rl', transform: 'rotate(180deg)' }}
        fontSize="md"
        fontWeight={400}
        whiteSpace="nowrap"
        letterSpacing="0.04em"
      >
        {label}
      </Text>
      <Flex
        w="26px"
        h="26px"
        borderRadius="full"
        border="1px solid"
        borderColor="currentColor"
        align="center"
        justify="center"
        flexShrink={0}
      >
        <Box
          as="svg"
          viewBox="0 0 24 24"
          w="12px"
          h="12px"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden
        >
          <polyline points="6 9 12 15 18 9" />
        </Box>
      </Flex>
    </Flex>
  );
}
